import { ConsoleAdapter } from '@redventures/incense/adapters/ConsoleAdapter'
import { useStoreState } from '@strata-monorepo/find-my-plan/src/lib/store/useStore'
import type { IncenseFactoryInstance } from '@redventures/incense/IncenseFactory'
import { IncenseFactory } from '@redventures/incense/IncenseFactory'

/**
 * React-friendly helper that always returns an Incense curried factory
 * bound to the *current* logger stored in the Easy-Peasy `logger` slice
 *
 * @returns {IncenseFactoryInstance} Factory with signature `(previousError?: unknown) => Incense`
 *
 * @example
 * ```tsx
 * const incense = useIncense()
 * incense(err).captureDetails({...}).sendError()
 * ```
 */
export function useIncense(): IncenseFactoryInstance {
  const activeLogger = useStoreState((state) => state.logger.logger) ?? new ConsoleAdapter()
  return IncenseFactory(activeLogger, 'strata-find-my-plan')
}
